import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';

import { AppointmentsHttpService, Prescription, refreshPrescriptionsData } from '@lib/prescriptions/data-access';
import { Store } from '@ngrx/store';
import { TranslatePipe } from '@ngx-translate/core';

import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';

import { formatDate } from '@lib/commons/util-functions/format-date.function';

import { WarningMessageComponent } from '@lib/shared-ui/commons/warning-message/warning-message.component';
import { LoaderComponent } from '@lib/shared-ui/layout/loader/loader.component';

import { PrescriptionModalItemComponent } from '../../commons/modal-item/prescription-modal-item.component';

export interface CancelAppointmentModalData {
  id: string;
  prescriptionId: string;
  appointmentName?: string;
  prescription?: Prescription;
  partnerName?: string;
  address?: string;
  startDate?: Date;
}

@Component({
  selector: 'prescriptions-cancel-appointment-modal',
  standalone: true,
  imports: [MatDialogModule, LoaderComponent, MatIcon, TranslatePipe, PrescriptionModalItemComponent, WarningMessageComponent],
  templateUrl: './cancel-appointment-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CancelAppointmentModalComponent {
  protected readonly data: CancelAppointmentModalData = inject(MAT_DIALOG_DATA);
  private readonly createAppointmentService = inject(AppointmentsHttpService);
  private readonly snackBar = inject(MatSnackBar);
  private readonly dialogRef = inject(MatDialogRef<CancelAppointmentModalComponent>);
  private readonly store = inject(Store);

  protected readonly loading = signal<boolean>(false);
  protected readonly formatDate = formatDate;

  protected readonly partnerName = () => this.data.partnerName || '';
  protected readonly address = () => this.data.address || '';
  protected readonly startDate = () => (this.data.startDate ? formatDate(this.data.startDate, true) : '');

  protected cancel() {
    this.dialogRef.close(false);
  }

  protected confirmCancellation() {
    this.loading.set(true);

    this.createAppointmentService.cancelAppointment(this.data.prescriptionId, this.data.id).subscribe({
      next: () => {
        this.store.dispatch(refreshPrescriptionsData());
        this.snackBar.open('Візит успішно видалено', 'OK', { duration: 5000 });
        this.dialogRef.close(true);
      },
      error: () => {
        this.snackBar.open('Не вдалось видалити візит', 'OK', { duration: 5000 });
        this.loading.set(false);
      },
    });
  }
}
